var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { setPageDetails, pushEventInfo, pushPageErrorInfo, pushErrorEvent, setEvent, } from './analytics';
var eventNamePrefix = 'user management';
export var setUserPageErrorAnalytics = function (type, displayType, pageSection, message, code) {
    pushPageErrorInfo({
        type: type,
        displayType: displayType,
        pageSection: pageSection,
        message: message,
        code: code,
    });
};
export var setUserPostPageErrorAnalytics = function (pageSection, displayType, errorCode, errorMessage) {
    pushErrorEvent(pageSection, displayType, errorCode, errorMessage);
};
export var setMyAccountPageAnalytics = function () {
    var page = {
        pageInfo: {
            pageName: 'account>add manage users',
            pageType: 'maml:account management',
        },
        catagory: {
            primaryCatagory: 'account',
            subCatagory1: 'account>add manage users',
            subCatagory2: 'account>add manage users',
        },
    };
    setPageDetails(page);
};
export var setBulkAddPageAnalytics = function () {
    var page = {
        pageInfo: {
            pageName: 'account>add manage users>bulk add',
            pageType: 'maml:account management',
        },
        category: {
            primaryCategory: 'account',
            subCategory1: 'account>add manage users',
            subCategory2: 'account>add manage users>bulk add',
        },
    };
    setPageDetails(page);
};
export var setBulkAddEventAnalytics = function (events) {
    setEvent('button submission', {
        eventName: 'my account settings',
    }, {
        myAccount: {
            settings: "user management: bulk: ".concat(events),
        },
    });
};
export var setSearchSortResultsAnalytics = function (actionType, numOfResults, _a, _b) {
    var sortBy = _a.sortBy, ascendingOrder = _a.ascendingOrder;
    var type = _b.type, value = _b.value;
    var searchType = type.toLowerCase();
    var searchValue = searchType === 'name' ? '' : value.toLowerCase();
    var settings = "user management: ".concat(actionType).concat(actionType === 'search' ? ": ".concat(numOfResults) : '');
    var getOrder = function (sortField, ascOrder) {
        var aToZOrderingFields = ['Name', 'Email', 'Role'];
        var isAToZ = aToZOrderingFields.includes(sortField);
        if (sortField === 'Status') {
            return ascOrder ? 'active first' : 'pending first';
        }
        if (isAToZ) {
            return ascOrder ? 'a to z' : 'z to a';
        }
        return ascOrder ? 'oldest to newest' : 'newest to oldest';
    };
    var order = getOrder(sortBy, ascendingOrder);
    var event = {
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: {
            settings: settings,
            searchTerm: "".concat(sortBy.toLowerCase(), ":").concat(order),
            searchBy: "".concat(searchType, ":").concat(searchValue),
        },
    };
    pushEventInfo(event);
};
var setOverlayAnalytics = function (action) {
    var event = {
        category: {
            primaryCategory: 'overlay',
        },
        eventInfo: {
            eventName: "".concat(eventNamePrefix, ": ").concat(action),
        },
    };
    pushEventInfo(event);
};
export var setAddUserOverlayAnalytics = function () { return setOverlayAnalytics('add user'); };
export var setEditUserOverlayAnalytics = function () {
    return setOverlayAnalytics('edit user');
};
export var setResendUserInvitesOverlayAnalytics = function () {
    return setOverlayAnalytics('resend user invites');
};
export var setRemoveUserOverlayAnalytics = function () {
    return setOverlayAnalytics('remove user');
};
var createAnalyticsEvent = function (settings, primaryCategory, eventMode) {
    if (primaryCategory === void 0) { primaryCategory = 'button submission'; }
    return (__assign({ category: {
            primaryCategory: primaryCategory,
        }, eventInfo: {
            eventName: 'my account settings',
        }, myAccount: {
            settings: settings,
        } }, (eventMode ? { eventMode: eventMode } : {})));
};
var pushUserManagementEvent = function (action, category, eventMode) {
    if (category === void 0) { category = 'button submission'; }
    if (eventMode === void 0) { eventMode = null; }
    var event = createAnalyticsEvent("".concat(eventNamePrefix, ": ").concat(action), category, eventMode);
    pushEventInfo(event);
};
export var setMeatBallsAnalytics = function (meatballAction) {
    var category = meatballAction === 'assign pro allowance' ? 'stash' : 'button submission';
    var eventMode = meatballAction === 'assign pro allowance' ? 'stash' : null;
    pushUserManagementEvent("meatball: ".concat(meatballAction), category, eventMode);
};
export var setRemoveUserSuccessAnalytics = function () {
    return pushUserManagementEvent('remove user');
};
export var setBulkRemoveUsersSuccessAnalytics = function (count) {
    return pushUserManagementEvent("bulk remove success: ".concat(count));
};
export var setResendUserInvitesSuccessAnalytics = function (count) {
    return pushUserManagementEvent("resend user invite success: ".concat(count));
};
export var setHeaderLinkAnalytics = function (linkName) {
    return pushUserManagementEvent("".concat(linkName));
};
export var setMultiSelectOperationLinkAnalytics = function (linkName) { return pushUserManagementEvent("multi select: ".concat(linkName, " link")); };
export var setPurchaserPermissionsToggleAnalytics = function (status) {
    return pushUserManagementEvent("purchaser permission toggle: ".concat(status));
};
export var setCardLinkAnalytics = function (linkName) {
    return pushUserManagementEvent("card: ".concat(linkName));
};
export var setAddUserSuccessAnalytics = function (userType) {
    return pushUserManagementEvent("card: ".concat(userType));
};
export var setEditUserSuccessAnalytics = function (userType) {
    return pushUserManagementEvent("edit user type: ".concat(userType));
};
